"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPathD = getPathD;
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clamp = _interopRequireDefault(require("lodash/clamp"));

var _classnames = _interopRequireDefault(require("classnames"));

var RADIUS = 50;
var DIAMETER = RADIUS * 2;

function clampPercent(data) {
  return (0, _clamp["default"])(data, 0, 100);
}

function clampWidth(data) {
  return (0, _clamp["default"])(data, 1, RADIUS);
} // stolen from https://github.com/chenglou/tween-functions/blob/master/index.js#L5


function linear(currentTime, beginValue, finalValue, duration) {
  return (finalValue - beginValue) * currentTime / duration + beginValue;
} // stolen from https://stash.atl.zillow.net/projects/NPM/repos/three-sphere-trackball-controls/browse/lib/makeTween.js


function makeTween(callback, startValue, endValue, duration) {
  var startTime = null;
  var context = {};

  var tick = function tick(timestamp) {
    startTime = startTime || timestamp;
    var delta = timestamp - startTime; // to arrive precisely on endValue,
    // ensure delta is no larger than duration

    delta = Math.min(delta, duration);

    if (delta >= duration) {
      context.completed = true;
    }

    return callback(delta, startValue, endValue, duration);
  };

  context.tick = tick;
  return context;
} // This method accepts a percentage (between 0 and 100) and returns a string that will be set as the value
// for an svg path's d attribute. (eg, <svg><path d="the return value from this method" /></svg>).  Using
// this method, the svg path will draw part of a donut.  input=25 generates one fourth of a donut, input=50
// generates half a donut etc


function getPathD(percentage, width) {
  var halfWidth = width / 2;
  var paddedRadius = RADIUS - halfWidth;
  var alpha = 360 / 100 * percentage;
  var largeArcFlag = alpha > 180 ? 1 : 0;
  var x;
  var y;

  if (percentage === 100) {
    x = RADIUS - 0.00001;
    y = halfWidth;
  } else {
    var a = (90 - alpha) * Math.PI / 180;
    x = RADIUS + paddedRadius * Math.cos(a);
    y = RADIUS - paddedRadius * Math.sin(a);
  }

  return "M" + RADIUS + "," + halfWidth + " A" + paddedRadius + "," + paddedRadius + ",0," + largeArcFlag + ",1," + x + "," + y;
}
/**
 * A ZSG styled, circular graph component.
 * The circular graph is filled to a user-specified percentage with animation.
 */


var Donut =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(Donut, _React$Component);

  function Donut(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Donut);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Donut).call(this, props));
    _this.state = {
      fillToPercent: clampPercent(props.percent),
      pathWidth: clampWidth(props.width),
      progressPercent: 0
    };
    _this.onTick = _this.onTick.bind((0, _assertThisInitialized2["default"])((0, _assertThisInitialized2["default"])(_this)));
    _this.requestFrameStep = _this.requestFrameStep.bind((0, _assertThisInitialized2["default"])((0, _assertThisInitialized2["default"])(_this)));
    return _this;
  } // start animation after delay when DOM is available


  (0, _createClass2["default"])(Donut, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      setTimeout(function () {
        return _this2.startAnimation();
      }, this.props.animationDelay);
    } // update state with clamped props when they change

  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var fillToPercent = clampPercent(nextProps.percent);
      var pathWidth = clampWidth(nextProps.width);

      if (this.state.fillToPercent !== fillToPercent || this.state.pathWidth !== pathWidth) {
        this.setState({
          fillToPercent: fillToPercent,
          pathWidth: pathWidth
        });
      }
    } // start animation after clamped props.percent changed

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.fillToPercent !== prevState.fillToPercent) {
        if (typeof requestAnimationFrame === 'function') {
          this.startAnimation();
        }
      }
    } // ensure animation is cancelled when unmounted

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (typeof requestAnimationFrame === 'function') {
        this.cancelFrameStep();
      }
    }
  }, {
    key: "cancelFrameStep",
    value: function cancelFrameStep() {
      if (this.rafToken) {
        cancelAnimationFrame(this.rafToken);
        this.rafToken = null;
      }
    }
  }, {
    key: "requestFrameStep",
    value: function requestFrameStep() {
      this.rafToken = requestAnimationFrame(this.onTick);
    } // setup tween and start requestAnimationFrame loop

  }, {
    key: "startAnimation",
    value: function startAnimation() {
      var _this$state = this.state,
          progressPercent = _this$state.progressPercent,
          fillToPercent = _this$state.fillToPercent;
      var animationDuration = this.props.animationDuration; // might be replacing in-flight

      this.cancelFrameStep();
      this.tween = makeTween(linear, progressPercent, fillToPercent, animationDuration);
      this.requestFrameStep();
    } // update state with new tick value, lazily re-entering loop if needed

  }, {
    key: "onTick",
    value: function onTick(timestamp) {
      var _this3 = this;

      this.setState({
        progressPercent: this.tween.tick(timestamp)
      }, function () {
        if (!_this3.tween.completed) {
          _this3.requestFrameStep();
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          backgroundColor = _this$props.backgroundColor,
          className = _this$props.className;
      var _this$state2 = this.state,
          pathWidth = _this$state2.pathWidth,
          progressPercent = _this$state2.progressPercent;
      var foregroundPathD = getPathD(progressPercent, pathWidth);
      var backgroundPathD = getPathD(100, pathWidth);
      var foregroundStyle = {
        strokeWidth: pathWidth + "px",
        stroke: color
      };
      var backgroundStyle = {
        strokeWidth: pathWidth + "px",
        stroke: backgroundColor
      };
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])('zsg-donut', className)
      }, _react["default"].createElement("svg", {
        viewBox: "0 0 " + DIAMETER + " " + DIAMETER,
        xmlns: "http://www.w3.org/2000/svg"
      }, _react["default"].createElement("path", {
        className: "zsg-donut-path zsg-donut-path_background",
        style: backgroundStyle,
        d: backgroundPathD
      }), _react["default"].createElement("path", {
        className: "zsg-donut-path zsg-donut-path_foreground",
        style: foregroundStyle,
        d: foregroundPathD
      })), _react["default"].createElement("div", {
        className: "zsg-donut-content"
      }, this.props.children));
    }
  }]);
  return Donut;
}(_react["default"].Component);

exports["default"] = Donut;
Donut.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The Donut animates from 0% to this value.  Must be between 0 and 100 inclusive.
   */
  percent: _propTypes["default"].number.isRequired,

  /**
   * Width of the Donut ring in pixels.  Must be between 0 and 50 inclusive.
   */
  width: _propTypes["default"].number,

  /**
   * Number of milliseconds that the Donut will take to perform its animation.
   */
  animationDuration: _propTypes["default"].number,

  /**
   * Number of milliseconds after mounting that the Donut animation will begin.
   */
  animationDelay: _propTypes["default"].number,

  /**
   * Color of the animating ring.
   */
  color: _propTypes["default"].string,

  /**
   * Color of the background ring.
   */
  backgroundColor: _propTypes["default"].string,

  /**
   * Additional classes to add to the root element.
   */
  className: _propTypes["default"].string,

  /**
   * Nodes to be placed inside the Donut
   */
  children: _propTypes["default"].node
} : {};
Donut.defaultProps = {
  percent: 0,
  width: 5,
  animationDuration: 1000,
  animationDelay: 500
};


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/react-zsg/Donut/index.js
// module id = 512
// module chunks = 0